import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
import {
    InputAdornment,
    FormControl,
    InputLabel,
    OutlinedInput,
    FormHelperText,
} from '@mui/material';
import { capitalize } from '../../utils/usefulFunctions';
import SuffixButton from './SuffixButton';
import useTranslate from '../../customHooks/useTranslate';

const StyledTextInput = styled(OutlinedInput)(() => ({
    '&:hover .text-input__delete-icon': {
        display: 'flex',
    },
    '&:not(:hover) .text-input__delete-icon': {
        display: 'none',
    },
    '& legend': {
        width: 0,
    },
}));

const StyledFormControl = styled(FormControl)(() => ({
    margin: 0,
    width: '100%',
    '& input:focus': {
        boxShadow: 'none',
    },
    '& label.Mui-focused': {
        width: 'auto',
        border: 0,
    },
    '& label.MuiInputLabel-shrink': {
        width: 'auto',
    },
}));

const TextInput = props => {
    const {
        labelText,
        errorMessage = '',
        helperText = '',
        id,
        handleChange,
        deleteIcon = true,
        prefix = null,
        suffix = null,
        formControlProps,
        labelProps,
        helperTextProps,
        disabled,
        readOnly,
        ...restProps
    } = props;

    const translate = useTranslate();
    const label = capitalize(translate(labelText));

    const helper = errorMessage || helperText;

    const handleChangeInput = e => handleChange(e, e.target.value);
    const inputRef = useRef();

    const clearText = () => {
        inputRef.current.focus();
        handleChange({ target: { name: id, value: '' } }, '');
    };

    return (
        <StyledFormControl
            size='small'
            required={restProps.required}
            error={!!errorMessage}
            {...formControlProps}
        >
            <InputLabel htmlFor={id} {...labelProps}>
                {label}
            </InputLabel>
            <StyledTextInput
                id={id}
                name={id}
                endAdornment={
                    readOnly ? null : (
                        <InputAdornment position='end'>
                            {prefix}
                            {deleteIcon && restProps.value && !disabled ? (
                                <SuffixButton
                                    classes={{
                                        root: 'text-input__delete-icon',
                                    }}
                                    iconName='Close'
                                    onClick={clearText}
                                />
                            ) : null}
                            {suffix}
                        </InputAdornment>
                    )
                }
                label={labelText}
                onChange={handleChangeInput}
                inputRef={inputRef}
                disabled={disabled}
                readOnly={readOnly}
                {...restProps}
            />
            {helper && (
                <FormHelperText {...helperTextProps}>
                    {translate(helper)}
                </FormHelperText>
            )}
        </StyledFormControl>
    );
};

export default TextInput;
